import { Box } from "@material-ui/core";
import {
  get as getError,
  Control,
  DeepMap,
  FieldError,
  UseFormMethods,
} from "react-hook-form";

import { DistributiveOmit, SimpleFormSchemaComponents } from "../../types";

import { Error } from "./Error";
import styles from "./withError.module.scss";

type ErrorsProps = {
  readonly errors: DeepMap<Record<string, unknown>, FieldError>;
};

export const withError = (
  WrappedComponent: React.NamedExoticComponent<any>
) => (
  props: DistributiveOmit<SimpleFormSchemaComponents, "type"> &
    ErrorsProps & {
      control?: Control;
      register?: UseFormMethods["register"];
      setValue?: UseFormMethods["setValue"];
      trigger?: UseFormMethods["trigger"];
    }
): JSX.Element => {
  const { errors, ...restProps } = props;
  const error = !restProps.disabled && getError(errors, props.id);

  return (
    <Box className={styles.withError}>
      <WrappedComponent
        {...restProps}
        hasError={!!error}
        error={error?.message}
      />
      {!!error && (
        <Error id={[props.id, "error"].join("-")}>{error.message}</Error>
      )}
    </Box>
  );
};
